import { httpClient } from './httpClient';

export interface Group {
    id: number;
    name: string;
    description?: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

export const groupService = {
    getAllGroups: async (): Promise<Group[]> => {
        try {
            return await httpClient.get<Group[]>('/api/groups');
        } catch (error) {
            return [];
        }
    },

    getGroupById: async (id: number) => {
        return httpClient.get<Group>(`/api/groups/${id}`);
    },

    createGroup: async (name: string, description?: string) => {
        return httpClient.post<Group>('/api/groups', { name, description });
    },

    updateGroup: async (id: number, name: string, description?: string) => {
        return httpClient.put<Group>(`/api/groups/${id}`, { name, description });
    },

    deleteGroup: async (id: number) => {
        return httpClient.delete<Group>(`/api/groups/${id}`);
    }
};
